import { z } from 'zod';
import { machinesSchema } from './machinesSchema';
import { roleSchema, permissionsSchema } from './roleSchema';
import { emailSchema, createNameSchema } from './directoryScheme';

export const nameHelper =
  'Full Name is case sensitive. It must have at least 2 characters, max 300 characters, no special characters allowed, no numbers allowed';
export const nameSchema = createNameSchema({
  name: 'Full Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: false,
  required: true,
});

export const usernameHelper =
  'Username is case insensitive. It must have at least 5 characters, one letter, and no spaces. It does not contain special characters';
export const usernameSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(5, { message: 'Username is required. Must be at least 5 characters' })
  .regex(/^\S*$/, {
    message: 'Username must not have spaces',
  })
  .regex(/^[A-Za-z0-9_]+$/, {
    message: 'Username must not contain special characters',
  })
  .regex(/[a-zA-Z]/, {
    message: 'Username must contain at least one letter',
  });

export const passwordHelper =
  'Password is case sensitive. It must have at least 8 characters, one uppercase letter, one lowercase letter, one number, one special character and no spaces';
export const loginPasswordHelper = 'Enter the password for this account.';
export const confirmPasswordHelper = 'Password must match';
export const loginPasswordSchema = z
  .string()
  .min(1, { message: 'Password is required' })
  .max(128, { message: 'Password must be less than 128 characters' });
export const passwordSchema = z
  .string()
  .trim()
  .min(8, { message: 'Password must be at least 8 characters' })
  .max(100, { message: 'Password must be less than 100 characters' })
  .regex(/^\S*$/, {
    message: 'Password must not have spaces',
  })
  .regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,100}$/,
    {
      message:
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    },
  );

export const titleHelper =
  'Job Title is case sensitive. It must have at least 2 characters';
export const titleSchema = createNameSchema({
  name: 'Job Title',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const userSchema = z.object({
  userid: z.number(),
  username: usernameSchema,
  name: nameSchema,
  email: emailSchema,
  title: titleSchema,
  roles: z.array(roleSchema),
  can_cut: z.boolean(),
  can_weld: z.boolean(),
  can_manual_fab: z.boolean(),
  can_notch: z.boolean(),
  can_cnc: z.boolean(),
  machines: z.array(machinesSchema),
  permissions: permissionsSchema,
});

export const userHelper = 'User is a required. Please select at least one user';
export const usersSchema = z.array(userSchema).min(1, userHelper);
export const usersOptionalSchema = z.array(userSchema).optional();
